import { render } from "./ShopSuccess.vue?vue&type=template&id=27d051e7"
import script from "./ShopSuccess.vue?vue&type=script&lang=js"
export * from "./ShopSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__